import React from 'react';
import { Card, Button, ListGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const UpgradePromoCard = ({ title, features = [], planName, onSeeMore }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleSeeMore = () => {
        if (onSeeMore) {
            onSeeMore();
        } else {
            navigate('/settings/plan');
        }
    };

    return (
        <Card className="h-100 text-center border-primary shadow-sm" style={{ backgroundColor: 'var(--ev-bg-subtle)' }}>
            <Card.Body className="d-flex flex-column justify-content-center align-items-center py-3">
                <div className="mb-2">
                    <i className="bi bi-lock-fill text-primary" style={{ fontSize: '2rem' }}></i>
                </div>
                <Card.Title as="h5" className="mb-2">
                    {title}
                </Card.Title>
                <Card.Text className="text-muted mb-3 small">
                    {t('dashboard.unlockFeaturesDescription', { plan: planName })}
                </Card.Text>

                {features.length > 0 && (
                    <ListGroup variant="flush" className="mb-3 w-100 bg-transparent">
                        {features.map((feature, index) => (
                            <ListGroup.Item key={index} className="bg-transparent border-0 py-0 small">
                                <i className="bi bi-check-circle-fill text-success me-2" style={{ fontSize: '0.8rem' }}></i>
                                {feature}
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                )}

                <Button variant="primary" size="sm" onClick={handleSeeMore} className="px-4 rounded-pill">
                    {t('dashboard.seeMore')}
                </Button>
            </Card.Body>
        </Card>
    );
};

export default UpgradePromoCard;
